/* unplugin-vue-components disabled */import { render } from "./CustomActionSheet.vue?vue&type=template&id=1b5f8568"
import script from "./CustomActionSheet.vue?vue&type=script&lang=js"
export * from "./CustomActionSheet.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__